document.addEventListener('DOMContentLoaded', function () {
  const searchInput = document.querySelector('.header-search__input');
  const body = document.body;
  const focusClass = 'search-focused';

  if (!searchInput) return;

  // On focus: add class if input is empty
  searchInput.addEventListener('focus', function () {
    if (searchInput.value.trim() === '') {
      body.classList.add(focusClass);
    }
  });

  // On input: remove class if input is not empty
  searchInput.addEventListener('input', function () {
    if (searchInput.value.trim() !== '') {
      body.classList.remove(focusClass);
    }
  });

  // Optional: remove class when input is blurred
  searchInput.addEventListener('blur', function () {
    body.classList.remove(focusClass);
  });
});
